<section class="process-area ptb-100 bg-fafafb">
  <div class="container">
    @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
      <div class="section-title">
        <span class="sub-title"><img src="assets/img/star-icon.png" alt="image"> {{sectionTitleContent.subTitle}}</span>
        <h2>{{sectionTitleContent.title}}</h2>
        <p>{{sectionTitleContent.paragraphText}}</p>
      </div>
    }

    <div class="row align-items-center m-0">
      <div class="col-lg-6 col-md-12 p-0">
        @for (Image of processImage; track Image) {
          <div class="process-image">
            <img [src]="Image.img" alt="Data analytics process">
          </div>
        }
      </div>

      <div class="col-lg-6 col-md-12 p-0">
        <div class="process-content">
          <div class="row">
            @for (Content of processContent; track Content) {
              <div class="col-lg-12 col-md-6">
                <div class="single-box-item">
                  <div class="d-flex align-items-center">
                    <div class="image">
                      <img [src]="Content.img" [alt]="Content.title + ' process icon'">
                    </div>
                    <h3>{{Content.title}}</h3>
                    <div class="number">{{Content.number}}</div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>